<template>
  <zm-input
    v-bind="$attrs"
    v-model="key"
    v-flex="{minWidth, inputPlaceHold, subfixWidth}"
    class="zm-flex-input"
    :placeholder="inputPlaceHold"
    :label="inputPlaceHold"
    @keyup.enter.native="submit"
    @focus="focusInput"
    @blur="blurInput"
  />
</template>

<script>
  import ZmInput from '../input';
  import flex from '../../directives/flex-input';

  export default {
    name: 'ZmFlexInput',
    model: {
      prop: 'modelValue',
      event: 'change'
    },
    props: {
      modelValue: {
        type: String,
        default: ''
      },
      subfixWidth: {
        type: Number,
        default: 0
      },
      longPlaceholder: {
        type: String,
        required: true
      },
      shortPlaceholder: {
        type: String,
        required: true
      },
      minWidth: {
        type: Number,
        default: 0
      }},
    components: {
      ZmInput
    },
    data() {
      return {
        isFocusing: false,
        key: this.modelValue
      };
    },
    watch: {
      key(newVal) {
        this.$emit('change', newVal);
      },
      modelValue(newVal) {
        this.key = newVal;
      }
    },
    methods: {
      submit() {
        this.$emit('submit', this.key);
      },
      focusInput() {
        this.isFocusing = true;
      },
      blurInput() {
        this.isFocusing = false;
      }
    },
    computed: {
      inputPlaceHold() {
        if (!this.isFocusing && this.key === '') {
          return this.shortPlaceholder;
        } else {
          return this.longPlaceholder;
        }
      }
    },
    directives: {
      flex
    }
  };
</script>

<style lang="scss">
  .zm-flex-input {
    transition: width 0.3s cubic-bezier(0, 1, 0.5, 1);
  }
</style>
